var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOntarioIconNotification = function SvgOntarioIconNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19v1H3v-1l2-2v-6a6.99 6.99 0 0 1 5-6.71V4a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.3a6.99 6.99 0 0 1 5 6.7v6zm-7 2a2 2 0 0 1-2 2 2 2 0 0 1-2-2"
  })));
};
export { SvgOntarioIconNotification as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PHBhdGggZD0iTTIxIDE5djFIM3YtMWwyLTJ2LTZhNi45OSA2Ljk5IDAgMCAxIDUtNi43MVY0YTIgMiAwIDAgMSAyLTIgMiAyIDAgMCAxIDIgMnYuM0E2Ljk5IDYuOTkgMCAwIDEgMTkgMTF2NmwyIDJ6bS03IDJhMiAyIDAgMCAxLTIgMiAyIDIgMCAwIDEtMi0yIiBmaWxsPSIiLz48L3N2Zz4=";